// Traduções dos popups HTML do mapa.
export default {
  pt: {
    'map.markers.contract': 'Contrato',
    'map.markers.destination': 'Destino',
    'map.markers.noTransmission': 'sem transmissão',
    'map.markers.noCategory': 'Sem categoria',
    'map.markers.hotel': 'Hotel',
    'map.markers.viewLodging': 'Ver hospedagem',
    'map.rastro.semHora': 'sem horário',
    'map.rastro.ponto': 'Ponto',
    'map.rastro.ignicaoLigada': 'Ignição ligada',
    'map.rastro.ignicaoDesligada': 'Ignição desligada',
    'map.rastro.odometro': 'Odômetro',
    'map.rastro.motoristaSemCadastro': 'motorista {{id}} sem cadastro no HUB',
  },
  en: {
    'map.markers.contract': 'Contract',
    'map.markers.destination': 'Destination',
    'map.markers.noTransmission': 'no transmission',
    'map.markers.noCategory': 'Uncategorized',
    'map.markers.hotel': 'Hotel',
    'map.markers.viewLodging': 'View lodging',
    'map.rastro.semHora': 'no timestamp',
    'map.rastro.ponto': 'Point',
    'map.rastro.ignicaoLigada': 'Ignition on',
    'map.rastro.ignicaoDesligada': 'Ignition off',
    'map.rastro.odometro': 'Odometer',
    'map.rastro.motoristaSemCadastro': 'driver {{id}} not registered in the HUB',
  },
  es: {
    'map.markers.contract': 'Contrato',
    'map.markers.destination': 'Destino',
    'map.markers.noTransmission': 'sin transmisión',
    'map.markers.noCategory': 'Sin categoría',
    'map.markers.hotel': 'Hotel',
    'map.markers.viewLodging': 'Ver hospedaje',
    'map.rastro.semHora': 'sin horario',
    'map.rastro.ponto': 'Punto',
    'map.rastro.ignicaoLigada': 'Ignición encendida',
    'map.rastro.ignicaoDesligada': 'Ignición apagada',
    'map.rastro.odometro': 'Odómetro',
    'map.rastro.motoristaSemCadastro': 'conductor {{id}} sin registro en el HUB',
  },
}
